import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import {
  getHasMoreSubfolders,
  getIsVisitorView,
  getStashFolder,
  getSubfolders,
  getVisibleSubfolders,
} from '../../../selectors/stash';
import { fetchMoreSubfolders } from '../../../actions/stash';
import { updateFolderOrder } from '../../../actions/studio/folders';
import { STASH_SUBFOLDERS_STREAM } from '../../../../constants';
import { Props } from './FolderListDesktop';
import { getSelectedFolder } from '../../../selectors/studio';
import { getIsBusy } from '../../../selectors/studio/folders';

export type StateProps = Pick<
  Props,
  | 'selectedFolder'
  | 'subfolders'
  | 'visibleSubfolders'
  | 'isBusy'
  | 'hasMoreSubfolders'
>;
export type DispatchProps = Pick<
  Props,
  'fetchMoreSubfolders' | 'updateFolderOrder'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  selectedFolder: getIsVisitorView(state)
    ? getStashFolder(state)!
    : getSelectedFolder(state)!,
  subfolders: getSubfolders(state),
  visibleSubfolders: getVisibleSubfolders(state),
  hasMoreSubfolders: getHasMoreSubfolders(state),
  isBusy: getIsBusy(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  fetchMoreSubfolders: () =>
    dispatch(fetchMoreSubfolders(STASH_SUBFOLDERS_STREAM.streamId)),
  updateFolderOrder: (folder, position) =>
    dispatch(updateFolderOrder(folder, position)),
});

export default connect(mapStateToProps, mapDispatchToProps);
